/**
 * 获取用户信息
 * */
import util from '@/utils/util';
import api from 'apis'

export default {
    namespaced: true,
    state: {
        hasGetInfo: false
    },
    mutations: {
        setHasGetInfo (state, status) {
            state.hasGetInfo = status
        },
        // 添加缓存
        ADD_CACHED_VIEW: (state, view) => {
            if (state.cachedViews.includes(view.name)) {
                return
            }
            state.cachedViews.push(view.name)
        },
        // 移除缓存
        DEL_CACHED_VIEW: (state, view) => {
            const index = state.cachedViews.indexOf(view.name)
            index > -1 && state.cachedViews.splice(index, 1)
            console.log('vuex数组', state.cachedViews);
        }
    },

    actions: {
        getTravelList ({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                // 开始请求登录接口
                api.travelList({ page: 1, pageSize: 10, city: '34' })
                    .then(async res => {
                        // util.cookies.set('x-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOiIzNzUyMzgxNzc1IiwiaWF0IjoiMTU3NTEwMTc3NSIsInV1aWQiOiJhZWY3YmE0NS1lNGNkLTQyMDAtOTE3Yy0zMjc0ZjhkYmNmZGUifQ.DXx8SFJusZmVcNfBAztJb5cD6nRO_cn-ZykzWgPYOQo');
                        console.log(res)
                        // 结束
                        resolve();
                    })
                    .catch(err => {
                        // console.log('err: ', err);
                        reject(err);
                    })
            })
        }

    }
};
